const landmark_keys = {
  left_eye_inner: 1,
  right_eye_inner: 4,
  left_shoulder: 11,
  right_shoulder: 12,
  left_eye: 2,
  left_eye_outer: 3,
  right_eye: 5,
  right_eye_outer: 6,
  left_mouth: 9,
  right_mouth: 10,
};

const face_landmark_keys = {
  left_iris_center: 468,
  left_iris_boundary_right: 469,
  left_iris_boundary_top: 470,
  left_iris_boundary_left: 471,
  left_iris_boundary_bottom: 472,
  right_iris_center: 473,
  right_iris_boundary_right: 474,
  right_iris_boundary_top: 475,
  right_iris_boundary_left: 476,
  right_iris_boundary_bottom: 477,
  left_eye_outer: 33,
  left_eye_inner: 133,
  right_eye_outer: 263,
  right_eye_inner: 362,
  left_eye_top: 159,
  left_eye_bottom: 145,
  right_eye_top: 386,
  right_eye_bottom: 374,
};

// Ideal values for each key for given frame/img in vid_outdict

const ideal_frame = {
  a_appropriate_distance_from_screen: "Appropriate distance from screen",
  b_centre_lr_of_screen: "Horizontal centre of screen",
  c_shoulders_horizontal: "Shoulders horizontal",
  d_head_directly_above_shoulder_centre: "Head directly above shoulder centre",
  e_eyes_horizontal: "Eyes horizontal",
  f_both_irises_at_centre_of_eye: "Both irises at centre of eye",
  g_forward_head: "Ear vertically above shoulder",
};

const visibility_thres = 0.9;

//  feedback_user_head_forward
const ratio_height_eye2mouth_eye2shoulder_max = 0.35;

// feedback_user_position_on_screen #distance from screen
const vertical_distance_bw_eyes_and_shoulders_min = 0.32; // 0.42
const vertical_distance_bw_eyes_and_shoulders_max = 0.65; // 0.55

const shoulder_x_min = 0.45;
const shoulder_x_max = 0.55;
const eye_inner_y_min = 0.7;
const eye_inner_y_max = 0.77;

//  feedback_shoulders_horizontal
const vertical_distance_bw_left_right_shoulder_max = 0.04; //0.05
const vertical_distance_bw_left_right_shoulder_min = -0.04; //-0.05

// feedback_eye_centre_directly_above_shoulder_center
const horizontal_distance_bw_eyes_shoulders_midpoint_max = 0.015; //0.025
const horizontal_distance_bw_eyes_shoulders_midpoint_min = -0.025; //-0.025

// feedback_eye_horizontal
const vertical_distance_bw_left_right_outer_eyes_min = -0.003; //-0.006
const vertical_distance_bw_left_right_outer_eyes_max = 0.009; //0.006

// left_iris_position_relative_to_eye & right_iris_position_relative_to_eye
const iris_horizontal_shift_max = 5;
const iris_horizontal_shift_min = -8;
// extreme left = -25%, extreme right =16%

const iris_vertical_shift_max = 15;
const iris_vertical_shift_min = 2;
// extreme down = -1.8%, extreme up =23%

// left_eye_open & right_eye_open
const eye_height_as_percent_of_width_min = 30;

// BGR color scheme
function feedback_color(feedback) {
  let feedback_bgr;
  if (Object.values(ideal_frame).includes(feedback)) {
    feedback_bgr = (34, 139, 34);
  } else {
    feedback_bgr = (0, 0, 128);
  }
  return feedback_bgr;
}

function feedback_user_position_on_screen(frame_landmarks) {
  const left_eye_inner = frame_landmarks[landmark_keys["left_eye_inner"]];
  const right_eye_inner = frame_landmarks[landmark_keys["right_eye_inner"]];
  const left_mouth = frame_landmarks[landmark_keys["left_mouth"]];
  const right_mouth = frame_landmarks[landmark_keys["right_mouth"]];
  const left_shoulder = frame_landmarks[landmark_keys["left_shoulder"]];
  const right_shoulder = frame_landmarks[landmark_keys["right_shoulder"]];
  let vertical_distance_bw_eyes_and_shoulders = -1;
  let feedback_dist_from_screen = "-1";
  let shoulder_x = -1;
  let feedback_head_forward = "-1";
  let ratio_height_eye2mouth_eye2shoulder = -99;
  let feedback_left_right_of_screen, feedback_empty_space_above_head;
  let screen_distance_check_pass = false;
  let screen_position_check_pass = false;
  if (
    left_eye_inner.visibility < visibility_thres ||
    right_eye_inner.visibility < visibility_thres
  ) {
    feedback_dist_from_screen = "Both eyes not visible";
    feedback_head_forward = "Both eyes not visible";
  }
  if (
    left_shoulder.visibility < visibility_thres ||
    right_shoulder.visibility < visibility_thres
  ) {
    feedback_dist_from_screen = "Both shoulders not visible";
    feedback_left_right_of_screen = "Both shoulders not visible";
    feedback_head_forward = "Both shoulders not visible";
  }
  if (
    left_eye_inner.visibility > visibility_thres &&
    right_eye_inner.visibility > visibility_thres &&
    left_shoulder.visibility >= visibility_thres &&
    right_shoulder.visibility >= visibility_thres
  ) {
    let eye_inner_y = (left_eye_inner.y + right_eye_inner.y) / 2;
    let mouth_y = (left_mouth.y + right_mouth.y) / 2;
    let shoulder_y = (left_shoulder.y + right_shoulder.y) / 2;
    let eye_to_mouth_height = (eye_inner_y - mouth_y, 2).toFixed(2);
    vertical_distance_bw_eyes_and_shoulders = (
      eye_inner_y - shoulder_y
    ).toFixed(2);
    // # Forward head logic
    ratio_height_eye2mouth_eye2shoulder = (eye_to_mouth_height /
      vertical_distance_bw_eyes_and_shoulders,
    2).toFixed(2);
    if (
      ratio_height_eye2mouth_eye2shoulder <=
      ratio_height_eye2mouth_eye2shoulder_max
    ) {
      feedback_head_forward = "Ear vertically above shoulder";
    } else if (
      ratio_height_eye2mouth_eye2shoulder >
      ratio_height_eye2mouth_eye2shoulder_max
    ) {
      feedback_head_forward = "Forward head. Move your head back";
    }
    //  Distance from screen logic
    if (
      vertical_distance_bw_eyes_and_shoulders >
      vertical_distance_bw_eyes_and_shoulders_max
    ) {
      feedback_dist_from_screen = "Too close to screen";
    } else if (
      vertical_distance_bw_eyes_and_shoulders <
      vertical_distance_bw_eyes_and_shoulders_min
    ) {
      feedback_dist_from_screen = "Too far from screen";
    } else if (
      vertical_distance_bw_eyes_and_shoulders <=
        vertical_distance_bw_eyes_and_shoulders_max &&
      vertical_distance_bw_eyes_and_shoulders >=
        vertical_distance_bw_eyes_and_shoulders_min
    ) {
      feedback_dist_from_screen = "Appropriate distance from screen";
      screen_distance_check_pass = true;
    }
  }
  if (
    left_shoulder.visibility > visibility_thres &&
    right_shoulder.visibility >= visibility_thres
  ) {
    shoulder_x = ((left_shoulder.x + right_shoulder.x) / 2).toFixed(2);
    if (shoulder_x < shoulder_x_min)
      feedback_left_right_of_screen = "Right of screen";
    else if (shoulder_x > shoulder_x_max)
      feedback_left_right_of_screen = "Left of screen";
    else if (shoulder_x >= shoulder_x_min && shoulder_x <= shoulder_x_max) {
      feedback_left_right_of_screen = "Horizontal centre of screen";
      screen_position_check_pass = true;
    }
  }
  //  Empty space above head feedback to be calculated whn usr is @ appropriate distance from screen
  if (feedback_dist_from_screen == "Appropriate distance from screen") {
    if (
      left_eye_inner.visibility > visibility_thres &&
      right_eye_inner.visibility > visibility_thres
    ) {
      let eye_inner_y = (left_eye_inner.y + right_eye_inner.y) / 2;
      //   # print ("eye_inner_y", eye_inner_y)
      if (eye_inner_y < eye_inner_y_min)
        feedback_empty_space_above_head = "Too much empty space above head";
      else if (eye_inner_y > eye_inner_y_max)
        feedback_empty_space_above_head = "Too less/No empty space above head";
      else if (eye_inner_y >= eye_inner_y_min && eye_inner_y <= eye_inner_y_max)
        feedback_empty_space_above_head = "Optimum empty space above head";
    }
  } else if (feedback_dist_from_screen != "Appropriate distance from screen") {
    feedback_empty_space_above_head = "";
  }
  return [
    { feedback_dist_from_screen, screen_distance_check_pass },
    { feedback_left_right_of_screen, screen_position_check_pass },
  ];
}

function feedback_shoulders_horizontal(frame_landmarks) {
  //    print (frame_landmarks)
  let vertical_distance_bw_left_right_shoulder = -1;
  const left_shoulder = frame_landmarks[landmark_keys["left_shoulder"]];
  const right_shoulder = frame_landmarks[landmark_keys["right_shoulder"]];
  let feedback_shoulders_bent;
  let shoulder_check_pass = false;
  if (
    left_shoulder.visibility < visibility_thres ||
    right_shoulder.visibility < visibility_thres
  )
    feedback_shoulders_bent = "Both shoulders not visible";
  if (
    left_shoulder.visibility > visibility_thres &&
    right_shoulder.visibility > visibility_thres
  ) {
    vertical_distance_bw_left_right_shoulder = (
      left_shoulder.y - right_shoulder.y
    ).toFixed(3);
    // # print("vertical_distance_bw_left_right_shoulder", vertical_distance_bw_left_right_shoulder)
    if (
      vertical_distance_bw_left_right_shoulder >
      vertical_distance_bw_left_right_shoulder_max
    )
      feedback_shoulders_bent = "Left shoulder higher than right shoulder";
    else if (
      vertical_distance_bw_left_right_shoulder <
      vertical_distance_bw_left_right_shoulder_min
    )
      feedback_shoulders_bent = "Right shoulder higher than left shoulder";
    else if (
      vertical_distance_bw_left_right_shoulder >=
        vertical_distance_bw_left_right_shoulder_min &&
      vertical_distance_bw_left_right_shoulder <=
        vertical_distance_bw_left_right_shoulder_max
    ) {
      feedback_shoulders_bent = "Shoulders horizontal";
      shoulder_check_pass = true;
    }
  }
  return [feedback_shoulders_bent, shoulder_check_pass];
}

function feedback_eye_centre_directly_above_shoulder_center(frame_landmarks) {
  const left_eye_inner = frame_landmarks[landmark_keys["left_eye_inner"]];
  const right_eye_inner = frame_landmarks[landmark_keys["right_eye_inner"]];
  const left_shoulder = frame_landmarks[landmark_keys["left_shoulder"]];
  const right_shoulder = frame_landmarks[landmark_keys["right_shoulder"]];
  let horizontal_distance_bw_eyes_shoulders_midpoint = -1;
  let feedback;
  let head_check_pass = false;

  if (
    left_eye_inner.visibility < visibility_thres ||
    right_eye_inner.visibility < visibility_thres
  )
    feedback = "Both eyes not visible";
  if (
    left_shoulder.visibility < visibility_thres ||
    right_shoulder.visibility < visibility_thres
  )
    feedback = "Both shoulders not visible";
  if (
    left_eye_inner.visibility > visibility_thres &&
    right_eye_inner.visibility > visibility_thres &&
    left_shoulder.visibility >= visibility_thres &&
    right_shoulder.visibility >= visibility_thres
  ) {
    let eye_inner_x = (left_eye_inner.x + right_eye_inner.x) / 2;
    // # print("eye_inner_x",eye_inner_x)
    let shoulder_x = (left_shoulder.x + right_shoulder.x) / 2;
    // # print("shoulder_x", shoulder_x)
    horizontal_distance_bw_eyes_shoulders_midpoint = eye_inner_x - shoulder_x;
    // # print("horizontal_distance_bw_eyes_shoulders_midpoint", horizontal_distance_bw_eyes_shoulders_midpoint)
    if (
      horizontal_distance_bw_eyes_shoulders_midpoint >
      horizontal_distance_bw_eyes_shoulders_midpoint_max
    )
      feedback = "Head left of shoulder centre";
    else if (
      horizontal_distance_bw_eyes_shoulders_midpoint <
      horizontal_distance_bw_eyes_shoulders_midpoint_min
    )
      feedback = "Head right of shoulder centre";
    else if (
      horizontal_distance_bw_eyes_shoulders_midpoint >=
        horizontal_distance_bw_eyes_shoulders_midpoint_min &&
      horizontal_distance_bw_eyes_shoulders_midpoint <=
        horizontal_distance_bw_eyes_shoulders_midpoint_max
    ) {
      feedback = "Head directly above shoulder centre";
      head_check_pass = true;
    }
  }
  // console.log(feedback)
  return [feedback, head_check_pass];
}

function feedback_eye_horizontal(frame_landmarks) {
  const left_eye_outer = frame_landmarks[landmark_keys["left_eye_outer"]];
  const right_eye_outer = frame_landmarks[landmark_keys["right_eye_outer"]];
  let vertical_distance_bw_left_right_outer_eyes = -1;
  let feedback;
  let eye_check_pass = false;

  if (
    left_eye_outer.visibility < visibility_thres ||
    right_eye_outer.visibility < visibility_thres
  )
    feedback = "Both eyes not visible";
  if (
    left_eye_outer.visibility > visibility_thres &&
    right_eye_outer.visibility > visibility_thres
  ) {
    vertical_distance_bw_left_right_outer_eyes =
      left_eye_outer.y - right_eye_outer.y;
    // # print("vertical_distance_bw_left_right_outer_eyes", vertical_distance_bw_left_right_outer_eyes)
    if (
      vertical_distance_bw_left_right_outer_eyes >
      vertical_distance_bw_left_right_outer_eyes_max
    )
      feedback = "Left eye higher than right eye";
    else if (
      vertical_distance_bw_left_right_outer_eyes <
      vertical_distance_bw_left_right_outer_eyes_min
    )
      feedback = "Right eye higher than left eye";
    else if (
      vertical_distance_bw_left_right_outer_eyes >=
        vertical_distance_bw_left_right_outer_eyes_min &&
      vertical_distance_bw_left_right_outer_eyes <=
        vertical_distance_bw_left_right_outer_eyes_max
    ) {
      feedback = "Eyes horizontal";
      eye_check_pass = true;
    }
  }
  return [feedback, eye_check_pass];
}

function throttleFunction(func, delay) {
  let prev = 0;
  return (...args) => {
    let now = new Date().getTime();
    if (now - prev > delay) {
      prev = now;
      return func(...args);
    }
  };
}

export {
  feedback_user_position_on_screen,
  feedback_eye_centre_directly_above_shoulder_center,
  feedback_shoulders_horizontal,
  feedback_eye_horizontal,
  throttleFunction,
};
